import React, { useEffect, useRef, useState } from "react";
import { Navigate } from "react-router-dom";
import { setAuthorization } from "../../helpers/api_helper";
import { useDispatch, useSelector } from "react-redux";
import MetaData from "../../components/MetaData";
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  Label,
  Input,
  FormFeedback,
  Spinner,
} from "reactstrap";
import Select from "react-select";
//formik
import { useFormik } from "formik";
import * as Yup from "yup";
import ImageOne from "./ImageOne";
import { useProfile } from "../../components/Hooks/UserHooks";
import { ToastContainer } from "react-toastify";
import { createNewPost, getAllCategories } from "../../slices/thunks";
import { Editor } from "@tinymce/tinymce-react";
import { handleImageSizeLimit } from "../../helpers/common";

const sortbycategory = [
  { label: "Technology", value: "Technology" },
  { label: "Shopping", value: "Shopping" },
  { label: "Business", value: "Business" },
  { label: "Health", value: "Health" },
  { label: "Fashion", value: "Fashion" },
  { label: "Travel", value: "Travel" },
  { label: "Lifestyle", value: "Lifestyle" },
  { label: "Digital Marketing", value: "Digital Marketing" },
  { label: "Website", value: "Website" },
  { label: "Online Marketing", value: "Online Marketing" },
];

const WritePost = () => {
  const dispatch = useDispatch();
  const editorRef = useRef(null);
  const [postLoading, setPostLoading] = useState(false);
  const [imageOne, setImageOne] = useState("");
  const { userProfile, loading, token } = useProfile();
  const [description, setDescription] = useState("");
  const { categories, isCategorySuccess } = useSelector((state) => ({
    categories: state.Posts.categories,
    isCategorySuccess: state.Posts.isCategorySuccess,
  }));
  const [categoryList, setCategoryList] = useState(categories);

  useEffect(() => {
    if (categories && !categories.length) {
      dispatch(getAllCategories());
    }
  }, []);

  useEffect(() => {
    setCategoryList(categories);
  }, [categories]);

  const transformedCategories = categories?.map((category) => ({
    label: category.categoryTitle,
    value: category._id,
  }));

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } 
  }, [token, userProfile, loading, dispatch]);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      title: "",
      category: "",
      imgOne: "",
      descriptionOne: "",
      status: "Pending",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please Enter Title"),
      category: Yup.string().required("Please Select Category"),
      imgOne: Yup.string().required("Please upload an image"),
    }),
    onSubmit: async (values) => {
      // console.log(values);
      try {
        setPostLoading(true);
        let desc = description;
        if (editorRef?.current) {
          desc = editorRef.current.getContent();
        }

        const newPost = {
          title: values["title"],
          category: values["category"],
          imgOne: values["imgOne"],
          descriptionOne: desc,
          status: "Pending",
        };

        let res = await dispatch(createNewPost(newPost));
        if (res?.payload?.status) {
          validation.resetForm();
          setImageOne("");
          setDescription("");
          validation.setFieldValue("category", ""); // Reset Category
          editorRef.current?.setContent(""); // Reset TinyMCE Editor
        }
      } catch (error) {
      } finally {
        setPostLoading(false);
      }
    },
  });

  useEffect(() => {
    if (editorRef.current && description) {
      editorRef.current.setContent(description);
    }
  }, [description]);

  if (!userProfile && loading && !token) {
    return <Navigate to={{ pathname: "/login" }} />;
  }

  return (
    <>
      <MetaData
        metaTitle={"Write-post"}
        metaDescription={"Softorithm write your post"}
        robots="noindex, nofollow"
      />
      <div className="page_body">
        <ToastContainer closeButton={false} />
        <div className="convert_tool_wrapper">
          <div className="pg_title">
            <h2>Write Your Post Here</h2>
          </div>

          <Row className=" justify-content-center ">
            <Col lg={7}>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
                action="#"
              >
                <Card>
                  <CardBody>
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="product-title-input"
                          >
                            Title
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="product-title-input"
                            placeholder="Enter Title"
                            name="title"
                            value={validation.values.title || ""}
                            onBlur={validation.handleBlur}
                            onChange={validation.handleChange}
                            invalid={
                              validation.errors.title &&
                              validation.touched.title
                                ? true
                                : false
                            }
                          />
                          {validation.errors.title &&
                          validation.touched.title ? (
                            <FormFeedback type="invalid">
                              {validation.errors.title}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="product-title-input"
                          >
                            Category
                          </Label>
                          <Select
                            value={transformedCategories?.find(
                              (option) =>
                                option.value === validation.values.category
                            )}
                            onChange={(e, selected) => {
                              validation.setFieldValue("category", e.value);
                            }}
                            className={`mb-0 ${
                              validation.touched.category &&
                              validation.errors.category
                                ? "is-invalid"
                                : ""
                            }`}
                            options={transformedCategories}
                            id="taginput-choices"
                          ></Select>
                          {validation.touched.category &&
                          validation.errors.category ? (
                            <FormFeedback type="invalid">
                              {validation.errors.category}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="product-title-input"
                          >
                            Image One
                          </Label>
                          <ImageOne
                            validation={validation}
                            imageOne={imageOne}
                            setImageOne={setImageOne}
                          />
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="mb-3">
                          <Label>Description</Label>
                          <Editor
                            onInit={(evt, editor) => {
                              editorRef.current = editor;
                              console.log({ editor: editor.initialized });
                            }}
                            initialValue={description}
                            init={{
                              image_resizing: true,
                              height: 500,
                              plugins: [
                                "advlist",
                                "lists",
                                "link",
                                "image",
                                "charmap",
                                "preview",
                                "anchor",
                                "searchreplace",
                                "visualblocks",
                                "fullscreen",
                                "insertdatetime",
                                "media",
                                "table",
                                "help",
                                "wordcount",
                                "directionality",
                              ],
                              toolbar:
                                "undo redo | casechange blocks | bold italic backcolor | " +
                                "alignleft aligncenter alignright alignjustify | " +
                                "bullist numlist checklist outdent indent | removeformat | a11ycheck code table help | link" +
                                "ltr rtl | a11ycheck code table help | link",

                              link_rel_list: [
                                {
                                  title: "Do Follow",
                                  value: "dofollow",
                                },
                                {
                                  title: "No Follow",
                                  value: "nofollow",
                                },
                              ],
                              content_style: "img { width:100%; height:auto; }",
                              menubar: "insert",
                              a11y_advanced_options: true,
                              setup: function (editor) {
                                let savedSelection;
                                editor.on("keyup", function (e) {
                                  if (e.keyCode === 32 || e.keyCode === 13) {
                                    editor.undoManager.add();
                                    savedSelection =
                                      editor.selection.getBookmark(2, true);
                                  }
                                });
                                editor.on("undo", function (e) {
                                  if (savedSelection) {
                                    editor.selection.moveToBookmark(
                                      savedSelection
                                    );
                                  }
                                });
                                editor.on("paste", function (e) {
                                  var clipboardData =
                                    e.clipboardData || window.clipboardData;
                                  var items = clipboardData.items;
                                  handleImageSizeLimit(e, items, editor);
                                });

                                editor.on("drop", function (e) {
                                  var items = e.dataTransfer.items;

                                  handleImageSizeLimit(e, items, editor);
                                });
                              },
                            }}
                          />
                          {validation.errors.descriptionOne &&
                            validation.touched.descriptionOne && ( // Check if there's an error for imageOne
                              <div className="text-danger">
                                {validation.errors.descriptionOne}
                              </div>
                            )}
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                <div className="text-end mb-3 mt-3">
                  <button type="submit" className="btn btn-success  ">
                    {postLoading ? (
                      <Spinner size="sm" className="me-2">
                        {" "}
                        Loading...{" "}
                      </Spinner>
                    ) : null}
                    Publish
                  </button>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default WritePost;
